const CookieManager = {
  getCookie: (name: string) => {
    const cookie = document.cookie
      .split(';')
      .find((row) => row.trim().startsWith(`${name}=`))
    return cookie && cookie.split('=')[1]?.trim()
  },
} as const

export default CookieManager
